import React from "react";
import {
  Page,
  Document,
  Image,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 14,
  },
  titulo: {
    fontSize: 24,
    fontWeight: "normal",
    padding: 4,
  },
  tituloMediano: {
    fontSize: 18,
    fontWeight: "normal",
    padding: 4,
  },
  dato: {
    fontSize: 24,
    fontWeight: "bold",
  },
  pagos: {
    fontWeight: "normal",
    paddingTop: 4,
    paddingLeft: 20,
  },
  pagosTitulo: {
    fontSize: 14,
  },
  pagoDestacado: {
    fontSize: 24,
    fontWeight: "bold",
  },
  totalPagos: {
    paddingLeft: 220,
  },
  compras: {
    fontWeight: "normal",
    paddingTop: 4,
    paddingBottom: 4,
  },
});

const ResumenDeCuentaPorFechas = ({
  nombreCliente,
  //monto,
  //fechaUltimoPago,
  pagosPorFecha,
  comprobantesPorFecha,
  rangoInferior,
  rangoSuperior,
}) => (
  <Document>
    <Page size="A4" style={styles.page} wrap>
      <View>
        <Text style={styles.tituloMediano}>
          Nombre: <Text style={styles.dato}>{nombreCliente}</Text>
        </Text>
        {
          // Si no hay pagos en la ultima fecha no se muestra el titulo
          pagosPorFecha.length > 0 && (
            <View>
              <Text style={styles.tituloMediano}>
                Movimientos realizados entre las fechas{" "}
                {dayjs(rangoInferior).format("DD/MM/YYYY")} y{" "}
                {dayjs(rangoSuperior).format("DD/MM/YYYY")}:
              </Text>
              <View style={styles.pagos}>
                {pagosPorFecha.map((pago, index) => (
                  <Text key={index} style={styles.pagoDestacado}>
                    {dayjs(pago.Fecha).format("DD/MM/YYYY")}
                    {"  "}-{"  "}
                    <Text style={styles.pagoDestacado}>
                      {pago.Tipo === "Tarjeta"
                        ? pago.Tipo.slice(0, 8) + "  "
                        : pago.Tipo.slice(0, 8)}
                      {"    "}Monto: ${pago.Total}
                    </Text>
                  </Text>
                ))}
              </View>
            </View>
          )
        }
        {comprobantesPorFecha.length > 0 && (
          <View style={styles.compras}>
            <Text style={styles.tituloMediano}>
              Compras realizadas entre las fechas {rangoInferior} y{" "}
              {rangoSuperior}:
            </Text>
            <View style={styles.pagos}>
              {comprobantesPorFecha.map((comprobante, index) => (
                <Text key={index} style={styles.pagoDestacado}>
                  {dayjs(comprobante.fecha).format("DD/MM/YYYY")}
                  {"    "}
                  <Text style={styles.pagoDestacado}>
                    Monto: ${comprobante.importe}
                  </Text>
                </Text>
              ))}
            </View>
          </View>
        )}
      </View>
    </Page>
  </Document>
);

export default ResumenDeCuentaPorFechas;
